<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Recruitment / Resourcing" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <div class="col-12">
            <p class="font-weight-bold mb-2 pt-0">The following information relates to future Resourcing and Recruitment placement opportunities for the worker.</p>
          </div>
          <!-- Placement Types -->
          <div class="col-xl-4 col-lg-6 form-group">
            <label class="form-label" for="job_types">Placement Types</label>
            <p id="job_types">
              <span v-if="worker.rel_recruitment_info.job_types !== null" v-for="(v, n) in JSON.parse(worker.rel_recruitment_info.job_types)">
                {{ v.value }}
                <span v-if="JSON.parse(worker.rel_recruitment_info.job_types).length > 1 && (n + 1) < JSON.parse(worker.rel_recruitment_info.job_types).length"> ,</span>
              </span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Industries -->
          <div class="col-xl-4 col-lg-6 form-group">
            <label class="form-label" for="industries">Industries</label>
            <p id="industries">
              <span v-if="worker.rel_recruitment_info.industries !== null" v-for="(v, n) in JSON.parse(worker.rel_recruitment_info.industries)">
                {{ v.sector.replace(/\s+/g, '&nbsp;') }}
                <span v-if="JSON.parse(worker.rel_recruitment_info.industries).length > 1 && (n + 1) < JSON.parse(worker.rel_recruitment_info.industries).length"> ,</span>
              </span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Job Titles -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="job_titles">Industries</label>
            <p id="job_titles">
              <span v-if="worker.rel_recruitment_info.job_titles !== null" v-for="(v, n) in JSON.parse(worker.rel_recruitment_info.job_titles)">
                {{ v.job_title.replace(/\s+/g, '&nbsp;') }}
                <span v-if="JSON.parse(worker.rel_recruitment_info.job_titles).length > 1 && (n + 1) < JSON.parse(worker.rel_recruitment_info.job_titles).length"> ,</span>
              </span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Health & Disabilities -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Health &amp; Disabilities</h5>
          </div>
          <!-- Any Health problems or disabilities? -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="any_health_disability">Any Health problems or disabilities?</label>
            <p id="any_health_disability">
              <span v-if="worker.rel_recruitment_info.any_health_disability">Yes</span>
              <span v-else-if="!worker.rel_recruitment_info.any_health_disability">No</span>
            </p>
          </div>
          <!-- Health/Disability Detail -->
          <div class="col-xl-4 form-group" v-if="worker.rel_recruitment_info.any_health_disability">
            <label class="form-label" for="health_disability_details">Health/Disability Detail</label>
            <p id="health_disability_details">
              <span v-if="worker.rel_recruitment_info.health_disability_details !== null"
                    v-html="worker.rel_recruitment_info.health_disability_details"></span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Special Requirements -->
          <div class="col-xl-4 form-group" v-if="worker.rel_recruitment_info.any_health_disability">
            <label class="form-label" for="health_disability_special_requirements">Special Requirements</label>
            <p id="health_disability_special_requirements">
              <span v-if="worker.rel_recruitment_info.health_disability_special_requirements !== null"
                    v-html="worker.rel_recruitment_info.health_disability_special_requirements"></span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Travel -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Travel</h5>
          </div>
          <!-- Have own transport? -->
          <div class="col-lg-6 form-group">
            <label class="form-label" for="have_own_transport">Have own transport?</label>
            <p id="have_own_transport">
              <span v-if="worker.rel_recruitment_info.have_own_transport">Yes</span>
              <span v-else-if="!worker.rel_recruitment_info.have_own_transport">No</span>
            </p>
          </div>
          <!-- Distance willing to travel? -->
          <div class="col-lg-6 form-group">
            <label class="form-label" for="distance_willing_to_travel">Distance willing to travel?</label>
            <p id="distance_willing_to_travel">
              <span v-if="worker.rel_recruitment_info.distance_willing_to_travel !== null">{{worker.rel_recruitment_info.distance_willing_to_travel}}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Criminal Convictions -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Criminal Convictions</h5>
          </div>
          <!-- Have any past or pending Criminal Convictions? -->
          <div class="col-lg-6 form-group">
            <label class="form-label" for="any_criminal_convictions">Have any past or pending Criminal Convictions?</label>
            <p id="any_criminal_convictions">
              <span v-if="worker.rel_recruitment_info.any_criminal_convictions">Yes</span>
              <span v-else-if="!worker.rel_recruitment_info.any_criminal_convictions">No</span>
            </p>
          </div>
          <!-- Criminal Conviction(s) Detail -->
          <div class="col-lg-6 form-group">
            <label class="form-label" for="criminal_convictions_details">Criminal Conviction(s) Detail</label>
            <p id="criminal_convictions_details">
              <span v-if="worker.rel_recruitment_info.criminal_convictions_details !== null"
                    v-html="worker.rel_recruitment_info.criminal_convictions_details"></span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Eduction/Qualifications -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Eduction / Qualifications</h5>
          </div>
          <!-- Education -->
          <div class="col-lg-6 form-group">
            <label class="form-label" for="education">Education</label>
            <p id="education">
              <span v-if="worker.rel_recruitment_info.education !== null"
                    v-html="worker.rel_recruitment_info.education"></span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Qualifications -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="qualifications">Qualifications</label>
            <p id="qualifications">
              <span v-if="worker.rel_recruitment_info.qualifications !== null" v-for="(v, n) in JSON.parse(worker.rel_recruitment_info.qualifications)">
                {{ v.qualification.replace(/\s+/g, '&nbsp;') }}
                <span v-if="JSON.parse(worker.rel_recruitment_info.qualifications).length > 1 && (n + 1) < JSON.parse(worker.rel_recruitment_info.qualifications).length"> ,</span>
              </span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Previous Employment -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Previous Employment</h5>
          </div>
          <!-- Employer 1 -->
          <div class="col-lg-6 form-group">
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold pt-0 mb-2">Employer 1</p>
              </div>
              <!-- Employer 1 Company Name -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_company">Company Name</label>
                <p id="prev_emp_1_company">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_company !== null">{{worker.rel_recruitment_info.prev_emp_1_company}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 Company Address -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_address">Company Address</label>
                <p id="prev_emp_1_address">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_address !== null">{{worker.rel_recruitment_info.prev_emp_1_address}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 Start Date -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_start_date">Start Date</label>
                <p id="prev_emp_1_start_date">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_start_date !== null">{{worker.rel_recruitment_info.prev_emp_1_start_date | formatDate}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 End Date -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_end_date">End Date</label>
                <p id="prev_emp_1_end_date">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_end_date !== null">{{worker.rel_recruitment_info.prev_emp_1_end_date | formatDate}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 Position -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_position">Position</label>
                <p id="prev_emp_1_position">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_position !== null">{{worker.rel_recruitment_info.prev_emp_1_position}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 Salary/wage -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_salary">Salary/wage</label>
                <p id="prev_emp_1_salary">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_salary !== null">{{worker.rel_recruitment_info.prev_emp_1_salary | currency}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 1 Reason for Leaving -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_1_reason_for_leaving">Reason for Leaving</label>
                <p id="prev_emp_1_reason_for_leaving">
                  <span v-if="worker.rel_recruitment_info.prev_emp_1_reason_for_leaving !== null"
                        v-html="worker.rel_recruitment_info.prev_emp_1_reason_for_leaving"></span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>
          <!-- Employer 2 -->
          <div class="col-lg-6 form-group">
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold pt-0 mb-2">Employer 2</p>
              </div>
              <!-- Employer 2 Company Name -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_company">Company Name</label>
                <p id="prev_emp_2_company">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_company !== null">{{worker.rel_recruitment_info.prev_emp_2_company}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 Company Address -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_address">Company Address</label>
                <p id="prev_emp_2_address">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_address !== null">{{worker.rel_recruitment_info.prev_emp_2_address}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 Start Date -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_start_date">Start Date</label>
                <p id="prev_emp_2_start_date">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_start_date !== null">{{worker.rel_recruitment_info.prev_emp_2_start_date | formatDate}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 End Date -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_end_date">End Date</label>
                <p id="prev_emp_2_end_date">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_end_date !== null">{{worker.rel_recruitment_info.prev_emp_2_end_date | formatDate}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 Position -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_position">Position</label>
                <p id="prev_emp_2_position">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_position !== null">{{worker.rel_recruitment_info.prev_emp_2_position}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 Salary/wage -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_salary">Salary/wage</label>
                <p id="prev_emp_2_salary">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_salary !== null">{{worker.rel_recruitment_info.prev_emp_2_salary | currency}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employer 2 Reason for Leaving -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="prev_emp_2_reason_for_leaving">Reason for Leaving</label>
                <p id="prev_emp_2_reason_for_leaving">
                  <span v-if="worker.rel_recruitment_info.prev_emp_2_reason_for_leaving !== null"
                        v-html="worker.rel_recruitment_info.prev_emp_2_reason_for_leaving"></span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>
          <!-- References -->
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">References</h5>
          </div>
          <!-- Reference 1 -->
          <div class="col-lg-6 form-group">
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold pt-0 mb-2">Reference 1</p>
              </div>
              <!-- Name -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_1_name">Name</label>
                <p id="reference_1_name">
                  <span v-if="worker.rel_recruitment_info.reference_1_name !== null">{{worker.rel_recruitment_info.reference_1_name}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Relationship -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_1_company_relationship">Relationship</label>
                <p id="reference_1_company_relationship">
                  <span v-if="worker.rel_recruitment_info.reference_1_company_relationship !== null">{{worker.rel_recruitment_info.reference_1_company_relationship}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Telephone -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_1_telephone">Telephone</label>
                <p id="reference_1_telephone">
                  <span v-if="worker.rel_recruitment_info.reference_1_telephone !== null">{{worker.rel_recruitment_info.reference_1_telephone}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Email -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_1_email">Email</label>
                <p id="reference_1_email">
                  <span v-if="worker.rel_recruitment_info.reference_1_email !== null">{{worker.rel_recruitment_info.reference_1_email}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>
          <!-- Reference 2 -->
          <div class="col-lg-6 form-group">
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold pt-0 mb-2">Reference 2</p>
              </div>
              <!-- Name -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_2_name">Name</label>
                <p id="reference_2_name">
                  <span v-if="worker.rel_recruitment_info.reference_2_name !== null">{{worker.rel_recruitment_info.reference_2_name}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Relationship -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_2_company_relationship">Relationship</label>
                <p id="reference_2_company_relationship">
                  <span v-if="worker.rel_recruitment_info.reference_2_company_relationship !== null">{{worker.rel_recruitment_info.reference_2_company_relationship}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Telephone -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_2_telephone">Telephone</label>
                <p id="reference_2_telephone">
                  <span v-if="worker.rel_recruitment_info.reference_2_telephone !== null">{{worker.rel_recruitment_info.reference_2_telephone}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Email -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="reference_2_email">Email</label>
                <p id="reference_2_email">
                  <span v-if="worker.rel_recruitment_info.reference_2_email !== null">{{worker.rel_recruitment_info.reference_2_email}}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "resourcing_recruitment",
  props: ['worker']
}
</script>

<style scoped>

</style>
